import React, { Fragment } from "react";

import img13 from "../../../images/service/Layer2/layer2-blockchain-banner1.png";
import img14 from "../../../images/service/Layer2/layer2-blockchain-banner2.png";
import img15 from "../../../images/service/Layer2/layer2-blockchain-banner3.png";

// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Layer-2 Crypto Architecture Design",
    content:
      "Design high-performance Layer-2 cryptocurrency architectures focused on speed, scalability, and low fees.",
  },
  {
    icon: sIcon2,
    title: "Custom Layer-2 Token Development",
    content:
      "Develop native Layer-2 cryptocurrencies with optimized transaction handling and settlement logic.",
  },
  {
    icon: sIcon3,
    title: "Layer-2 Wallet & Exchange Integration",
    content:
      "Integrate Layer-2 cryptocurrencies with wallets, bridges, and exchanges for seamless adoption.",
  },
];

const benefits = [
  {
    title: "Ultra-Low Transaction Fees",
    description:
      "Layer-2 cryptocurrencies dramatically reduce transaction costs compared to Layer-1 networks.",
    icon: sIcon1,
  },
  {
    title: "High Throughput",
    description:
      "Support thousands of transactions per second without network congestion.",
    icon: sIcon2,
  },
  {
    title: "Improved User Experience",
    description:
      "Faster confirmations enable smooth payments and real-time crypto usage.",
    icon: sIcon3,
  },
  {
    title: "Layer-1 Security",
    description:
      "Layer-2 cryptocurrencies inherit the security guarantees of the underlying blockchain.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What is Layer-2 cryptocurrency development?",
    a: "Layer-2 cryptocurrency development involves building digital currencies on top of Layer-1 blockchains to improve scalability, speed, and transaction costs.",
  },
  {
    q: "Why use Layer-2 for cryptocurrencies?",
    a: "Layer-2 solutions reduce fees and increase throughput while maintaining Layer-1 security.",
  },
  {
    q: "Can Layer-2 cryptocurrencies work with Ethereum?",
    a: "Yes. Many Layer-2 cryptocurrencies are built to integrate seamlessly with Ethereum.",
  },
  {
    q: "Are Layer-2 cryptocurrencies secure?",
    a: "Yes. They leverage the security model of the underlying Layer-1 blockchain.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function Layer2CryptocurrencyDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Layer-2 Cryptocurrency Development"
        pagesub="Fast, scalable & cost-efficient crypto solutions"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Build Scalable Cryptocurrencies with{" "}
            <span className="gradient-text">Layer-2 Technology</span>
          </>
        }
        subtitle={`Create high-performance cryptocurrencies that deliver fast
transactions, minimal fees, and seamless scalability using Layer-2 solutions.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Layer-2 Cryptocurrency Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="Why Layer-2 for Cryptocurrency Development?"
        image={img14}
        paragraphs={[
          "Traditional cryptocurrencies often face scalability bottlenecks, high transaction fees, and slow confirmation times during peak usage.",
          "Layer-2 cryptocurrencies solve these issues by processing transactions off-chain while settling securely on the base blockchain.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Layer-2 Cryptocurrency Development Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Limitations of Layer-1 Cryptocurrencies"
        image={img15}
        paragraphs={[
          "Layer-1 blockchains prioritize decentralization and security, which can limit transaction speed and increase fees.",
          "Layer-2 cryptocurrency solutions overcome these challenges by shifting computation off-chain without compromising trust.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Layer-2 Cryptocurrency Development"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Layer-2 Crypto Solutions"
        subtitle="Engineered for speed, scalability, and adoption"
        features={[
          {
            icon: sIcon1,
            title: "High-Speed Transactions",
            description:
              "Instant payments and fast finality for real-world use cases.",
          },
          {
            icon: sIcon2,
            title: "Low-Cost Transfers",
            description:
              "Minimal fees suitable for micropayments and high-frequency usage.",
          },
          {
            icon: sIcon3,
            title: "Ethereum Compatibility",
            description:
              "Seamless interaction with Ethereum wallets and dApps.",
          },
          {
            icon: sIcon4,
            title: "Secure Settlement",
            description:
              "Final settlement anchored to Layer-1 security.",
          },
          {
            icon: sIcon5,
            title: "Scalable Token Economy",
            description:
              "Support large user bases without performance degradation.",
          },
          {
            icon: sIcon6,
            title: "Ecosystem Integration",
            description:
              "Easy integration with DeFi platforms and exchanges.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Deep expertise in Layer-2 cryptocurrency design",
          "Security-first and performance-optimized development",
          "End-to-end crypto launch and integration support",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
